import {
  type CrmRelationsGetRechtsvormOptiesDto as RechtsvormOptie,
  type CrmRelationsGetRechtsvormOptiesDto,
} from '@services/crm-public/orval-api/model/crmRelationsGetRechtsvormOptiesDto';
import { useRelatiesGetRechtsvormopties } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import { ref, watch, type Ref } from 'vue';

export const useRechtsvormSelect = (rechtsvormCodeModel?: Ref<string>) => {
  const modelValue = ref<RechtsvormOptie>();
  const options = ref<RechtsvormOptie[]>([]);

  const { data } = useRelatiesGetRechtsvormopties({ query: { select: (x) => x.result } });

  watch(
    data,
    (newValue) => {
      if (Array.isArray(newValue)) {
        options.value = newValue;
      }
    },
    { immediate: true },
  );

  if (rechtsvormCodeModel !== undefined) {
    watch(
      [rechtsvormCodeModel, options],
      ([newValue]) => {
        if (newValue === modelValue.value?.code) return;

        if (!Array.isArray(options.value)) return;

        const selectedOption = options.value!.find((x) => x.code === newValue);
        modelValue.value = selectedOption || undefined;
      },
      { immediate: true },
    );
  }

  return {
    options,
    modelValue,
    props: {
      optionLabel: 'omschrijving' as keyof CrmRelationsGetRechtsvormOptiesDto,
      'onUpdate:modelValue': (value?: RechtsvormOptie[] | RechtsvormOptie | null) => {
        if (rechtsvormCodeModel !== undefined) {
          rechtsvormCodeModel.value = Array.isArray(value) ? value[0].code : value?.code || '';
        }
      },
    },
  };
};
